<template>
  <div class="flex flex-col h-full bg-white animate-pulse">
    <!-- Chat Header Skeleton -->
    <div class="flex items-center justify-between p-4 border-b border-gray-200 bg-white">
      <div class="flex items-center gap-3 flex-1">
        <!-- Avatar -->
        <div class="h-10 w-10 bg-gray-200 rounded-full"></div>
        <!-- Name and status -->
        <div class="space-y-2">
          <div class="h-4 bg-gray-200 rounded w-32"></div>
          <div class="h-3 bg-gray-200 rounded w-20"></div>
        </div>
      </div>
      <!-- Action buttons -->
      <div class="flex gap-2">
        <div class="h-8 w-8 bg-gray-200 rounded-full"></div>
      </div>
    </div>

    <!-- Messages Area Skeleton -->
    <div class="flex-1 overflow-hidden p-4 space-y-4">
      <!-- Incoming message -->
      <div class="flex items-start gap-2">
        <div class="h-8 w-8 bg-gray-200 rounded-full flex-shrink-0"></div>
        <div class="space-y-2 flex-1 max-w-xs">
          <div class="h-16 bg-gray-200 rounded-2xl rounded-tl-sm"></div>
          <div class="h-3 bg-gray-200 rounded w-16"></div>
        </div>
      </div>

      <!-- Outgoing message -->
      <div class="flex items-start gap-2 justify-end">
        <div class="space-y-2 max-w-xs">
          <div class="h-12 bg-gray-200 rounded-2xl rounded-tr-sm"></div>
          <div class="h-3 bg-gray-200 rounded w-16 ml-auto"></div>
        </div>
      </div>

      <!-- Incoming message -->
      <div class="flex items-start gap-2">
        <div class="h-8 w-8 bg-gray-200 rounded-full flex-shrink-0"></div>
        <div class="space-y-2 flex-1 max-w-xs">
          <div class="h-20 bg-gray-200 rounded-2xl rounded-tl-sm"></div>
          <div class="h-3 bg-gray-200 rounded w-16"></div>
        </div>
      </div>

      <!-- Outgoing message -->
      <div class="flex items-start gap-2 justify-end">
        <div class="space-y-2 max-w-xs">
          <div class="h-14 bg-gray-200 rounded-2xl rounded-tr-sm"></div>
          <div class="h-3 bg-gray-200 rounded w-16 ml-auto"></div>
        </div>
      </div>

      <!-- Incoming message -->
      <div class="flex items-start gap-2">
        <div class="h-8 w-8 bg-gray-200 rounded-full flex-shrink-0"></div>
        <div class="space-y-2 flex-1 max-w-xs">
          <div class="h-10 bg-gray-200 rounded-2xl rounded-tl-sm"></div>
          <div class="h-3 bg-gray-200 rounded w-16"></div>
        </div>
      </div>
    </div>

    <!-- Input Area Skeleton -->
    <div class="border-t border-gray-200 p-4">
      <div class="flex items-center gap-2">
        <div class="h-10 w-10 bg-gray-200 rounded-full"></div>
        <div class="flex-1 h-10 bg-gray-200 rounded-full"></div>
        <div class="h-10 w-10 bg-gray-200 rounded-full"></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// No props needed - this is a static skeleton
</script>
